import * as ActionTypes from './action-types.constants';
import * as WebViewActions from '@medscape-promo/medscapetv/web-view/web-view.actions';
import { PLAYLIST_TRACKING, EMBD_LNK } from '@medscape-promo/medscapetv/omniture-tracking';

function handleEpisodeClick(storeAPI, el){
	storeAPI.dispatch(WebViewActions.omnitureTracking(EMBD_LNK,el));
}

function handleSliderBeforeChange(storeAPI, oldIndex, newIndex) {
    const { mmodule, mlink } = PLAYLIST_TRACKING;
    const mlinkValue = (newIndex > oldIndex) ? mlink.next : mlink.prev;
    const trackingValue = `${mmodule}_${mlinkValue}`;
    storeAPI.dispatch(WebViewActions.omnitureTracking(trackingValue));
}
const MainMiddleware = storeAPI => next => action => {
    // Do something in here, when each action is dispatched
    //const state = storeAPI.getState();
    //console.log('[MainMiddleware] current state', state)
    //console.log('[MainMiddleware] dispatching', action.type);
    //console.log("[MainMiddleware] ModalActionTypes.OPEN:", ModalActionTypes.OPEN);

    let result = next(action);
    //const nextState = storeAPI.getState();
    //console.log('[MainMiddleware] next state', nextState);
    switch (action.type) {
        case ActionTypes.SLIDER_BEFORE_CHANGE:
            handleSliderBeforeChange(storeAPI, action.oldIndex, action.newIndex);
            break;
        case ActionTypes.CLICK_EPISODE:
        	handleEpisodeClick(storeAPI,action.el);
        	break;

    }

    return result
}

export default MainMiddleware;